import { currencySymbolByCode } from "components/allForm/SalesItem/currencyJson";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { pmtNumberFormate } from "jsFunctions/helperFunctions";
import { InvoiceNumberFormate } from "jsFunctions/helperFunctions";
import moment from "moment";

export const getInvoiceGstExcelData = (gstList) => {
    let list = JSON.parse(JSON.stringify(gstList));
    const exportData = list.map((data, index) => {
    const totalGst = Number(data?.amt?.i || 0) + Number(data?.amt?.s || 0) + Number(data?.amt?.c || 0) 
      let content = {
        "no": index + 1,
        "Invoice No": data?.inId?.inNo && InvoiceNumberFormate(data?.inId?.inNo),
        "Invoice Date": data?.inId?.inDt && moment(data?.inId?.inDt).format("DD-MMM-YYYY"),
        "Invoice Currency": data?.inId?.inCr && data?.inId?.inCr,
        "Client Name":  data?.cId?.clName,
        "GST Number":  data?.gstNo,
        "Base Amount":  `₹ ${data?.bsAmt  ? formatAmountIndianRupees(data?.bsAmt ) : Number(0).toFixed(2)}`,
        "IGST Amount": `₹ ${data?.amt?.i  ? formatAmountIndianRupees(data?.amt?.i) : Number(0).toFixed(2)}`,
        "SGTS Amount": `₹ ${data?.amt?.s  ? formatAmountIndianRupees(data?.amt?.s) : Number(0).toFixed(2)}`,
        "CGST Amount": `₹ ${data?.amt?.c  ? formatAmountIndianRupees(data?.amt?.c) : Number(0).toFixed(2)}`,
        "Total GST Amount": `₹ ${totalGst ? formatAmountIndianRupees(totalGst) : Number(0).toFixed(2)}`,
      };

      return content;
    });
    return exportData;
  };

  export const getInvoiceTDSExcelData = (gstList) => {
    let list = JSON.parse(JSON.stringify(gstList));
    const exportData = list.map((data, index) => {
      let content = {
        "no": index + 1,
        "Invoice No": data?.inId?.inNo && InvoiceNumberFormate(data?.inId?.inNo),
        "Invoice Date": data?.inId?.inDt && moment(data?.inId?.inDt).format("DD-MMM-YYYY"),
        "Invoice Currency": data?.inId?.inCr && data?.inId?.inCr,
        "Client Name":  data?.cId?.clName,
        "Base Amount":  `${currencySymbolByCode(data?.inId?.inCr || "INR")} ${data?.bsAmt  ? formatAmountIndianRupees(data?.bsAmt ) : Number(0).toFixed(2)}`,
        "TDS Percentage": `${data?.prc ? data?.prc : 0} %`,
        "TDS Amount": `${currencySymbolByCode(data?.inId?.inCr || "INR")} ${data?.tdsAmt ? formatAmountIndianRupees(data?.tdsAmt) : Number(0).toFixed(2)}`,
      };

      return content;
    });
    return exportData;
  };

  export const getInvoicePaymentExcelData = (gstList) => {
    let list = JSON.parse(JSON.stringify(gstList));
    const exportData = list.map((data, index) => {
      let content = {
        "no": index + 1,
        "Invoice No": data?.inId?.inNo && InvoiceNumberFormate(data?.inId?.inNo),
        "Invoice Date": data?.inId?.inDt && moment(data?.inId?.inDt).format("DD-MMM-YYYY"),
        "Invoice Currency": data?.inId?.inCr && data?.inId?.inCr,
        "Client Name":  data?.cId?.clName,
        "Payment ID": data?.pyNo && pmtNumberFormate(data?.pyNo),
        "Amount":  `${currencySymbolByCode(data?.inId?.inCr || "INR")} ${data?.amt  ? formatAmountIndianRupees(data?.amt ) : Number(0).toFixed(2)}`,
        "Bank Charge": `${currencySymbolByCode(data?.inId?.inCr || "INR")} ${data?.crg ? formatAmountIndianRupees(data?.crg) : Number(0).toFixed(2)}`,
        "Referance No": data?.ref && data?.ref,
        "Payment Date": data?.dt && moment(data?.dt).format("DD-MMM-YYYY"),
        "Payment Mode": data?.mod && data?.mod?.val,

      };

      return content;
    });
    return exportData;
  };